import React, { useState } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import FaqForm from "../../components/faqs/FaqForm";
import { convertToFormData } from "../../shared/upload";
import {
  initialValues,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL
} from "../../shared/enums/faqs_enum";
import { useUpdateFaq, useSingleFaq, useGetDropdownOptions } from "../../shared/hooks/UseFaq";
// import { useSelectAllFaq } from "../../shared/hooks/UseFaq";

const EditFaq = ({ match }) => {
  let history = useHistory();
  const [single_data] = useSingleFaq(match.params.id);
  const [updateData] = useUpdateFaq();
  const { faq_loading, faq, edit_faq_loading } = single_data;
  const [featuredImage, setFeaturedImage] = useState(null);



  const [dropdownOptions, loadOptions] = useGetDropdownOptions();
  const submitFormClicked = async values => {
    const data = await convertToFormData({ values, featuredImage });
    await updateData(faq._id, data);
    history.push(`/${LINK_URL}/${faq._id}/view`);
  };



  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={`Edit ${PAGE_SINGLE_TITLE}`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!faq_loading ? (
              faq && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {faq[Object.keys(inputFields)[0]]} -{" "}
                        <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link
                          to={`/${LINK_URL}`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-angle-left"></i> {PAGE_TITLE}
                        </Link>
                        <Link
                          to={`/${LINK_URL}/${faq._id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <FaqForm
                    data={faq}
                    edit={true}
                    featuredImage={featuredImage}
                    setFeaturedImage={setFeaturedImage}
                    submitForm={submitFormClicked}
                    inputFields={inputFields}
                    initialValues={initialValues}
                    dropdown_options={dropdownOptions}
                    loading={edit_faq_loading}
                    loadOptions={loadOptions}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditFaq;
